import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapThead = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTThead');
});
var bootStrapThead = function (props) {
    return React.createElement(BootStrapThead, __assign({}, props));
};
export var Thead = function (props) {
    var componentToDisplay = bootStrapThead(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapThead(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Thead.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Thead;
//# sourceMappingURL=Thead.js.map